import { FC } from 'react'

import Button from 'components/forms/Button'
import imageResize from 'project/image-proxy-web'
import { useRouter } from 'next/router'
import useShoppingBag from 'common/useShoppingBag'
import { TPlanSummary } from 'common/cms-types'
import { I18NConfig } from 'next/dist/server/config-shared'
import { createClient } from '../../../prismicio'
import { Utils } from 'common/utils'
import { getPlans } from 'common/planData'
import SubscriptionPricing from 'components/SubscriptionPricing'

type Props = {
  planSummary: TPlanSummary
}

const LondonVOPlusHeroCard: FC<Props> = ({ planSummary }) => {
  const router = useRouter()
  const { addPlan } = useShoppingBag()

  const onBuyClick = () => {
    addPlan(planSummary.slug, 'year', planSummary)
    router.push('/checkout')
  }
  return (
    <div className='card card_bg-gradient-purple-pink d-flex flex-column px-4 pt-8 pb-5 ps-lg-8 pe-lg-12 py-lg-10'>
      <h2 className='fs-fluid-52-96 lh-105 mb-0 color-white'>
        London
        <br /> Virtual Office
      </h2>
      <div className='fs-fluid-26-48 mb-8 lh-105 fw-semibold'>
        <span className='text-white'>+</span>{' '}
        <span className='text-body fw-bold'>HaiRo™</span>
        <span className='fw-semibold'>
          : AI-Powered
          <br /> Mail Management
        </span>
      </div>
      <SubscriptionPricing
        className='text-white mb-8'
        locationClassName='fw-semibold text-white gap-1 fs-fluid-24-26 mb-4 color-pink2'
        hideCTA
        priceClass='fs-fluid-24-36 fw-semibold mt-4'
        monthClass='fs-fluid-18-24 fw-semibold mt-4'
        priceSubClass='fs-fluid-18-24 fw-semibold'
        planSummary={planSummary}
      />
      <div className='d-flex flex-column flex-lg-row gap-6 mt-9 mt-lg-9'>
        <Button
          theme='outlineWhite'
          className='w-100'
          onClick={() => {
            router.push('/virtual-office-london-old-street')
          }}
        >
          Find out more
        </Button>
        <Button onClick={onBuyClick} className='w-100'>
          Buy Now
        </Button>
      </div>
    </div>
  )
}
export async function getStaticProps(
  context: I18NConfig & { locale?: string; params: { uid: string } },
) {
  try {
    const client = createClient(context)
    const lang = Utils.getLocaleID(context.locale || context.defaultLocale)
    const plans = await getPlans()
    return {
      props: {
        plans,
      },
    }
  } catch (e) {
    console.log(e)
    return {
      props: {},
    }
  }
}
export default LondonVOPlusHeroCard
